import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./i18n/i18n";
import { App } from "./App";
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/shell.css";
import "./styles/setup.css";
import "./styles/game.css";
import "./styles/overlays.css";

const rootElement = document.getElementById("root");

if (rootElement === null) {
  throw new Error("Missing #root application mount point");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
